import { css } from 'styled-components';

const fonts = css`
  @import url('https://fonts.googleapis.com/css?family=IBM+Plex+Sans:400,500,600,700');
  @import url('https://fonts.googleapis.com/css?family=IBM+Plex+Mono:700,700i');
`;

export default fonts;



// WEBPACK FOOTER //
// ./src/styles/global/fonts.js